<template lang="pug" src="./article.pug"></template>
<style lang="scss" src="./article.scss" scoped></style>

<script>
import { mapState } from 'vuex';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import validate from '@/mixins/validate';
import {VListItem, VListItemAction, VListItemContent, VListItemTitle} from "vuetify/lib/components";

export default {
    components: {
      'v-list-tile': VListItem,
      'v-list-tile-content': VListItemContent,
      'v-list-tile-title': VListItemTitle,
      'v-list-tile-action': VListItemAction
    },
    mixins: [validationMixin, validate],
    data: () => ({
        dropdown: false,
        resultShow: false
    }),
    validations: {
        article: {
            title: {
                required
            },
            body: {
                maxLength: function() {
                    return this.article.body.length;
                }
            },
            phoneFilters: {
                maxLength: function() {
                    return this.filterPhones.length <= 500;
                }
            }
        }
    },
    computed: {
        ...mapState({
            filters: state => state.driverNews.filters,
            article: state => state.driverNews.article,
            count: state => state.driverNews.count,
            drivers: state => state.driverNews.drivers,
            normalizePhones: state => state.driverNews.normalizePhones,
            result: state => state.driverNews.result,
            isLoaded: state => state.driverNews.isLoaded
        }),
        isDisabled: function() {
            return !!this.filters.phones.length;
        },
        showPhoneEditor() {
            return this.filters.sendTo === 'selected';
        },
        messageForm() {
            return !this.showPhoneEditor || (this.normalizePhones && this.normalizePhones.success &&
                this.normalizePhones.success.length);
        },
        androidErrors() {
            return [];
            // return Object.entries(this.result.android.errors).map(([key, value]) => ({ key, value }));
        },
        iosErrors() {
            return [];
            // return Object.entries(this.result.ios.errors).map(([key, value]) => ({ key, value }));
        },
        filterPhones() {
            return this.filters.phones && this.filters.phones.split('\n').filter(it => !!it);
        }
    },
    created: function() {
        this.getDriverList(this.filters.sendTo);
    },
    methods: {
        getDriverList(scope) {
            this.$store.dispatch('driverNews/getDrivers', scope);
        },
        toggleShown() {
            this.$store.commit('driverNews/UPDATE_ARTICLE', { 'shown': !this.article.shown });
        },
        setSendTo(val) {
            this.$store.commit('driverNews/SET_SELECTION', val);

            this.getDriverList(val);
        },
        setArticleField(field, val) {
            this.$store.commit('driverNews/UPDATE_ARTICLE', { [field]: val });
        },
        async sendArticle() {
            if (this.$v.$invalid) {
                this.$v.$touch();
            } else {
                await this.$store.dispatch('driverNews/createArticle');
                this.$store.commit('driverNews/CLEAR_ARTICLE');
                this.$store.dispatch('alert/addMessage', {
                    message: 'createdArticle',
                    type: 'success',
                    locale: true
                });

                // this.$nextTick(() => {
                //     this.$v.$reset()
                //     this.resultShow = true
                //     setTimeout(() => {
                //         scroll(this.$refs.resultCard)
                //     }, 100)
                // })
            }
        },
        validatePhones() {
            this.resultShow = false;

            if (this.$v.article.phoneFilters.$invalid) {
                this.$v.article.phoneFilters.$touch();
                return;
            }

            if (!this.filterPhones.length) {
                this.$store.commit('driverNews/SET_COUNT', 0);
            }
            this.$store.dispatch('driverNews/validatePhones', this.filterPhones);
        }
    }
};
</script>
